import './styles/index.less'
// import './assets/icon/iconfont.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
// import 'iview/dist/styles/iview.css'
import { apiFetch } from './axios/api'
import * as echarts from 'echarts'
import ECharts from 'vue-echarts'
Vue.component('v-chart', ECharts)

import fullscreen from 'vue-fullscreen'
Vue.use(fullscreen);

Vue.use(iView)
Vue.prototype.$echarts = echarts
Vue.prototype.$api = apiFetch
Vue.config.productionTip = false
Vue.prototype.checkPermission = function(permission, callback) {
  let checkPermission = () => {
    const flag = store.state.rightCodeList.some(item => {
      if (item === permission) {
        return true
      }
    })
    if (flag) {
      callback()
    } else {
      this.loading = false
      this.$Message.error({
        content: '该用户没有权限！'
      })
    }
  }
  if (!store.state.rightCodeList.length) {
    store
      .dispatch('getRightCodeList')
      .then(res => {
        if (res.data.code === '0') {
          checkPermission()
        } else {
          this.$Message.error({
            content: res.data.message
          })
        }
      })
      .catch(error => {
        this.$Message.error({
          content: error.res.data.message
        })
      })
  } else {
    checkPermission()
  }
}
new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$store.commit('setTagsList')
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js